export default "__VITE_ASSET__ggeY$1Ab__"